import React from 'react';
import { createRoot } from 'react-dom/client';
import Page from './Page';
import Corparate from './components/Corparate';
import FullBook from './components/FullBook';
import './style/index.css'
import { BrowserRouter, Route, Router, Routes } from 'react-router-dom';
// import "primereact/resources/themes/lara-light-indigo/theme.css";
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<Page />} />
                <Route path='/corporate' element={<Corparate />} />
                <Route path='/fullbook' element={<FullBook />} />
            </Routes>

        </BrowserRouter>
    </React.StrictMode>
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
